import React from 'react';
import { connect } from 'react-redux';
import {
  getFunnelExecutionResult,
  getFunnelExecutionTime,
  getFunnelView,
  getProjectZoneId,
} from '../../reducers/analyticsApp';
import toConversionConfig from '../FunnelChart';
import Chart from '../Chart';
import FunnelLabelsPane from '../../containers/labels/FunnelLabelsPane';

const FunnelChart = ({ data, options, executeTime, view }) => (
  <div>
    {data && (
      <div style={{ height: '400px' }}>
        <Chart key={executeTime} config={toConversionConfig(data, options, view)} />
        <div className="st-labels-chart">
          <FunnelLabelsPane />
        </div>
      </div>
    )}
  </div>
);

const mapStateToProps = (state) => ({
  data: (getFunnelExecutionResult(state) || {}).chart,
  executeTime: getFunnelExecutionTime(state),
  options: { timezone: getProjectZoneId(state) },
  view: getFunnelView(state),
});

const ConversionChart = connect(mapStateToProps, null)(FunnelChart);

export default ConversionChart;
